module.exports = __webpack_public_path__ + "images/花筑奢pr长图_05.jpg?v=f2b42914";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_05.jpg
 ** module id = 36
 ** module chunks = 1 2
 **/